export const hasActualFlightOffer = (actualData: any): boolean =>
  Boolean(actualData?.actualFlightOffer);

export type MissingActualFlightOfferFallback =
  | "brandModal"
  | "notFoundError"
  | "customFlightNotFoundError";

export const getMissingActualFlightOfferFallback = ({
  isAppMobile,
  brandsDetailsAvailable,
}: {
  isAppMobile: boolean;
  brandsDetailsAvailable: boolean;
}): MissingActualFlightOfferFallback => {
  if (brandsDetailsAvailable) {
    return "brandModal";
  }

  return isAppMobile ? "notFoundError" : "customFlightNotFoundError";
};
